export function translateWordToPersion(word: string): string {
  const dictionary: Record<string, string> = {
    categories: "دسته بندی",
    grades: "پایه تحصیلی",
    majors: "رشته",
    lessons: "دروس",
    contenttypes: "نوع محتوا",
    mostdiscount: "بیشترین تخفیف",
    mostexpensive: "گران ترین ها",
    mostcheap: "ارزان ترین ها",
    "categories-1": "ابتدایی",
    "categories-2": "متوسطه اول",
    "categories-3": "متوسطه دوم",
    "categories-4": "امتحان نهایی",
    "categories-5": "کنکور",
    "grades-1": "اول",
    "grades-2": "دوم",
    "grades-3": "سوم",
    "grades-4": "چهارم",
    "grades-5": "پنجم",
    "grades-6": "ششم",
    "grades-7": "هفتم",
    "grades-8": "هشتم",
    "grades-9": "نهم",
    "grades-10": "دهم",
    "grades-11": "یازدهم",
    "grades-12": "دوازدهم",

    "majors-1": "ریاضی",
    "majors-2": "تجربی",
    "majors-3": "انسانی",

    "lessons-1": "زبان انگلیسی",
    "lessons-2": "هدیه های آسمان",
    "lessons-3": "ریاضی",
    "lessons-4": "عربی",
    "lessons-5": "علوم تجربی",
    "lessons-6": "فارسی",
    "lessons-7": "مطالعات اجتماعی",
    "lessons-8": "نگارش",
    "lessons-9": "جغرافیا",
    "lessons-10": "زیست شناسی",
    "lessons-11": "هندسه",
    "lessons-12": "فیزیک",
    "lessons-13": "دین و زندگی",
    "lessons-14": "عربی , زبان قرآن",
    "lessons-15": "شیمی",
    "lessons-16": "هویت اجتماعی",
    "lessons-17": "جغرافیای ایران",
    "lessons-18": "فلسفه",
    "lessons-19": "تاریخ",
    "lessons-20": "جامعه شناسی",
    "lessons-21": "روانشناسی",
    "lessons-22": "ریاضی و آمار",
    "lessons-23": "علوم و فنون ادبی",
    "lessons-24": "منطق",
    "lessons-25": "حسابان",
    "lessons-26": "آمار و احتمال",
    "lessons-27": "تاریخ معاصر",
    "lessons-28": "ریاضیات گسسته",
    "lessons-29": "تحلیل فرهنگی",
    "lessons-30": "آمادگی دفاعی",
    "lessons-31": "فرهنگ و هنر",
    "lessons-32": "کار و فناوری",
    "lessons-33": "آموزش قرآن",
    "lessons-34": "تفکر و سبک زندگی",
    "lessons-35": "آزمایشگاه علوم تجربی",
    "lessons-36": "تعلیمات دینی",
    "lessons-37": "اقتصاد",
    "lessons-38": "تفکر و سواد رسانه ای",
    "lessons-39": "زمین شناسی",
    "lessons-40": "انسان و محیط زیست",
    "lessons-41": "سلامت و بهداشت",
    "lessons-42": "مدیریت خانواده و سبک زندگی",
    "lessons-43": "تفکر و پژوهش",
    "lessons-44": "کارگاه کارآفرینی و تولید",
    "lessons-45": "پیام های آسمان",

    "contenttypes-0": "پکیج آموزشی",
    "contenttypes-1": "ویدیو",
    "contenttypes-2": "کتاب درسی",
    "contenttypes-3": "خلاصه نکات",
    "contenttypes-4": "نمونه سوالات حل شده",
  };

  return dictionary[word.toLowerCase()] || "فیلتر انتخاب شده";
}
